var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComparses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.373,0,0,5.373,0,12c0,6.627,5.373,12,12,12c6.627,0,12-5.373,12-12C24,5.373,18.627,0,12,0z  M17.739,14.05c-0.858,3.542-5.996,5.945-9.376,3.805c-1.753-1.102-2.675-2.772-2.094-4.727c0.204-0.61,0.572-1.151,1.065-1.563 c0.01-0.935,0.221-1.856,0.618-2.703c0.41-0.918,1.983-0.406,1.568,0.517c-0.174,0.399-0.307,0.815-0.397,1.241 c0.95-0.276,1.967-0.204,2.869,0.203c0.704,0.394,1.15,1.127,1.178,1.933c0.044,1.273-0.952,2.34-2.225,2.384 c-1.208,0.027-2.348-0.556-3.035-1.55c-0.151,0.434-0.168,0.903-0.051,1.347c0.493,1.955,2.855,2.458,4.916,1.997 c2.338-0.54,3.819-2.343,3.436-4.713c-0.335-1.913-1.672-3.498-3.5-4.151c0.055,0.364,0.014,0.254,0.088,0.618 c0.18,0.853-1.171,1.301-1.563,0.493c-0.26-0.614-0.472-1.248-0.632-1.895c-0.066-0.355,0.127-0.708,0.461-0.844l0.129-0.069 c0.074-0.059,0.158-0.103,0.249-0.129c0.587-0.373,1.219-0.669,1.882-0.881c0.397-0.1,0.804,0.126,0.928,0.517 c0.129,0.405-0.094,0.837-0.496,0.97C16.577,8.162,18.494,10.986,17.739,14.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.669,13.584c0.443,0.046,0.941-0.074,1.001-0.503c0.095-0.411-0.139-0.827-0.54-0.959 c-0.668-0.238-1.404-0.193-2.038,0.125C9.237,13.008,9.894,13.565,10.669,13.584z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparses);
export default __webpack_public_path__ + "static/media/comparses.0526b49a.svg";
export { ForwardRef as ReactComponent };